import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import MuiButton from '../muiButton'
import { LEGEND_TEXT_COLOR_MAP } from '../../constants'

export const Wrapper = styled('ul')(
  (props) => `
    ${props.maxHeight ? `
    max-height : ${props.maxHeight}px;
    overflow-y : auto;  
    & > li { margin-right : 4px; }

    &::-webkit-scrollbar { width: 6px; }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(173, 173, 173, 1);  
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track { background: transparent; }

    &::-webkit-scrollbar-thumb:hover { background-color: #555; }   
    ` : ''}
    padding-left:15px;
    width:100%;
    padding: 0px 0px 10px 0px;
    list-style:none;
    background-color:${props.bg}
`
)

export const VerbatimGridWrapper = styled(Box)(
  (props) => `
    ${props.maxHeight ? `
    max-height : ${props.maxHeight}px;
    overflow-y : auto;  
    padding-right : 4px;

    &::-webkit-scrollbar { width: 6px; }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(173, 173, 173, 1);  
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track { background: transparent; }

    &::-webkit-scrollbar-thumb:hover { background-color: #555; }   
    ` : ''}
`
)

export const Content = styled('li')(`
    position: relative;
    line-height: 18px;
    padding: 8px 0px 8px 0px;
    font-weight: 400;
    font-size: 13px;
    border-bottom: 1px solid #D8D8D6;
    display: flex;
    align-items: flex-start;
    gap: 6px;

    &.Positive { color: #1B9A65; }

    &.Negative { color: #C61F2B; }

    &.Mixed { color: #636B73; }

    .icon{ margin-top: 1px; }
 
`)

export const IconWrap = styled(Box)(` `)

export const InputContainer = styled(Box)(` `)

export const InputWrap = styled(Box)(`
    &.top { margin-bottom: 20px; }
    & label { margin-bottom: 2px; }
`)

export const ModalTitle = styled(Typography)(`
  margin-top: 10px;
  padding-bottom: 30px;
  font-style: normal;
  font-weight: 400; // 300;
  font-size: 20px;
  line-height: 30px;
  text-align: left;
  color: #000;
`)

export const ModalWrapper = styled(Box)(`
  width:100%;
  max-width: 600px;
  width: 80vw;
`)

export const ModalButton = styled(MuiButton)(`
  // float: left;
  margin-left: 0px !important;
  margin-top: 20px !important;
`)

export const Text1 = styled('span')(`
  display:block;
  overflow-wrap: anywhere;
`)

export const Text2 = styled('span')(`
  color:#000;
  margin-left:8px;
  font-size:12px;
`)
